import { Fragment } from 'react';
import { MessageCircle, ExternalLink, ArrowRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useCancellationPlan } from 'src/context/billing';
import env from 'env';

import CallToActionBanner from './CallToActionBanner';

const PlanUsageWarning = () => {
  const {
    ui: { setStep },
  } = useCancellationPlan();

  const onExploreSolutions = () => window.open('https://codekeeper.co/solutions', '_blank');

  const onContactUs = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  const onReviewAccountUse = () => setStep('review-account-usage');

  return (
    <Fragment>
      <CallToActionBanner
        title="Think your plan is not the right fit?"
        description="Learn more about our other solutions with the best prices on the market."
        action={
          <Button variant="secondary" onClick={onExploreSolutions}>
            Explore solutions <ExternalLink />
          </Button>
        }
        variant="secondary"
      />
      <CallToActionBanner
        title="Review your account use"
        description="Your Codekeeper account is still actively being used for application continuity. To continue with canceling your account, please make sure the account cancellation requirements are met."
        action={
          <Button variant="secondary" onClick={onReviewAccountUse}>
            Review account use <ArrowRight />
          </Button>
        }
        variant="secondary"
      />
      <CallToActionBanner
        title="Need some help?"
        description="If you’re having trouble with the Codekeeper application, or any of your solutions, please get in touch. We’re here to help."
        action={
          <Button variant="outline" onClick={onContactUs}>
            <MessageCircle /> Contact us
          </Button>
        }
      />
    </Fragment>
  );
};

export default PlanUsageWarning;
